






































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { JinroGamePlayinfoDocument } from "@/services/datatypes";
import JinroGame from "../JinroPlayer/JinroGame.vue";
import { JinroPlayStatus } from "@/services/jinro-play-status";
import SelectResult from "@/components/shared/SelectResult.vue";

@Component({
  components: {
    SelectResult,
  },
})
export default class JinroPlayinfoActivity extends Vue {
  @Prop() readonly playinfo!: JinroGamePlayinfoDocument;

  isDay(playStatus: JinroPlayStatus): boolean {
    return playStatus === JinroPlayStatus.Day;
  }
  isVote(playStatus: JinroPlayStatus): boolean {
    return playStatus === JinroPlayStatus.Vote;
  }
  isExtraVote(playStatus: JinroPlayStatus): boolean {
    return playStatus === JinroPlayStatus.ExtraVote;
  }
  isExecution(playStatus: JinroPlayStatus): boolean {
    return playStatus === JinroPlayStatus.Execution;
  }
  isNight(playStatus: JinroPlayStatus): boolean {
    return playStatus === JinroPlayStatus.Night;
  }
  isEnding(playStatus: JinroPlayStatus): boolean {
    return playStatus === JinroPlayStatus.Ending;
  }

  skipHr(playStatus: JinroPlayStatus): boolean {
    const skipStatuses = [JinroPlayStatus.Prologue, JinroPlayStatus.AfterNight];
    return skipStatuses.includes(playStatus);
  }
}
